/**
 * This is lazy loading config that initiate when open the webpage
 * DON'T import any module here. Ohterwise, the module will be loaded and lost the lazy loading.
 * */

import { withAsync } from '../../components/lazyLoading/async-component';
import myPrivilegesSaga from '../../modules/myPrivileges/sagas/index';
import myPrivilegesReducers from '../../modules/myPrivileges/reducers/index';
import { t } from '../../locales';

// Folder name of the module for lazy import
const MODULE_FOLDER_NAME = 'myPrivileges';

// Module name from package.json
const MODULE_NAME = 'hk-emma-web-module-my-privileges';

// Root path of the routes
const ROOT_PATHS = ['marketplace/myprivileges'];

// State if you have any other module to load
const ADDITION_MODULE_FOLDER_NAMES = [
  'axagoal',
  'offers',
  'ps-casemanagement',
  'ps-cdp',
  'ps-chronicdiseasemanagement',
  'ps-cosmeticdermatology',
  'ps-fanclskinandhealthtest',
  'ps-fertilitysolution',
  'ps-general',
  'ps-hkshwellnessexperience',
  'ps-jadediabetes',
  'ps-leadformmeetourconsultant',
  'ps-luckydraw',
  'ps-manninghealthcollaboration',
  'ps-maternityservices',
  'ps-meditation',
  'ps-mental-health-guru',
  'ps-moodgym',
  'ps-offer-one',
  'ps-oxford-vr',
  'ps-preventionstage',
  'ps-preventionstageplus',
  'ps-refractivesurgery',
  'ps-sensely',
  // 'ps-senselysymptomchecker',
  'ps-smiling-mind',
  'ps-storytaler',
  'ps-stress-care',
  'ps-teleconsultation',
  'ps-treatmentandrehabilitationstafe',
  'ps-treatmentandrehabilitationstafeplus',
  'ps-wellnessprogramme',
  'ps-womenproductlead',
  'ps-exclusiveoffers',
  'ps-happyaging',
  'ps-valueaddedservice',
  'ps-pinkmedical',
];

export default {
  preloadModules: [
    {
      moduleFolderNames: [...ADDITION_MODULE_FOLDER_NAMES, MODULE_FOLDER_NAME],
    },
  ],
  modules: [
    {
      moduleName: MODULE_NAME,
      routes: {
        rootPaths: ROOT_PATHS,
        subPaths: {
          '': {
            exact: true,
            sidebarItem: {
              label: t('MYPRIVILEGES_LABEL'),
              iconDefault: `/assets/images/myprivileges.svg`,
              iconSelected: `/assets/images/myprivileges-selected.svg`,
              priority: 200,
            },
            container: withAsync(MODULE_FOLDER_NAME, ''),
          },
          '/seeall': {
            exact: true,
            container: withAsync(MODULE_FOLDER_NAME, '/seeall'),
          },
          '/:cardViewId': {
            exact: true,
            container: withAsync(MODULE_FOLDER_NAME, '/:cardViewId'),
          },
        },
      },
    },
  ],
};
